import { render, staticRenderFns } from "./LabelledContent.vue?vue&type=template&id=4ebf58e9&scoped=true"
import script from "./LabelledContent.vue?vue&type=script&lang=js"
export * from "./LabelledContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf58e9",
  null
  
)

export default component.exports